import { clsx, type ClassValue } from 'clsx';
import { motion, AnimatePresence } from 'motion/react';
import { extendTailwindMerge } from 'tailwind-merge';

// Re-export motion for use in apps
export { motion, AnimatePresence };

// tailwind-merge no conoce los fontSize custom del DS (`text-label`, `text-cell`,
// `text-h1`, etc.). Por defecto los clasifica como COLOR y, al mezclarlos en el
// mismo `cn()` con un `text-{color}` (p.ej. `text-label` + `text-tkf-fg`), los
// considera del mismo grupo `text-*` y descarta el primero → se pierde el
// `font-size` y el texto hereda un tamaño mayor. Registrarlos en el grupo
// `font-size` lo corrige para todo el DS (bug latente en cualquier componente
// que combine un tamaño custom + un color de texto vía `cn`).
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            '2xs',
            'label',
            'datepicker',
            'cell',
            'movement',
            'empty-state',
            'onboarding-cta',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'small',
            'micro',
          ],
        },
      ],
    },
  },
});

/**
 * Merge Tailwind CSS classes with clsx
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Generate unique ID
 */
export function generateId(prefix = 'id'): string {
  return `${prefix}-${Math.random().toString(36).substr(2, 9)}`;
}

// =============================================================================
// Motion Variants
// =============================================================================

/**
 * Hover/tap scale animation variants for buttons and interactive elements
 * @param hover - Scale factor on hover (default: 1.09)
 * @param tap - Scale factor on tap/click (default: 0.97)
 */
export const varHover = (hover = 1.09, tap = 0.97) => ({
  hover: { scale: hover },
  tap: { scale: tap },
});

/**
 * Common motion transitions with custom easing
 */
export const motionTransition = {
  hover: {
    duration: 0.32,
    ease: [0.43, 0.13, 0.23, 0.96] as const,
  },
  drawer: {
    duration: 0.225,
    ease: [0.4, 0, 0.2, 1] as const,
  },
  enter: {
    duration: 0.64,
    ease: [0.43, 0.13, 0.23, 0.96] as const,
  },
  exit: {
    duration: 0.48,
    ease: [0.43, 0.13, 0.23, 0.96] as const,
  },
};
